import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LocalstorageService {
	dataUpdated = new EventEmitter();
constructor() {
    // this.init();
  }
	// Set Local storage data
	public setData(key:string, data:any) {
		localStorage.setItem(key, JSON.stringify(data));
		this.dataUpdated.emit();
	}
	// Get Local Storage data
	public getData(key:string) {
		return JSON.parse(localStorage.getItem(key));
	}
	// Remove local storage data
	public removeData(key:string) {
		localStorage.removeItem(key);
	}

	// private init(): void {
	// 	window.addEventListener('beforeunload', () => {
	// 	  // Clear all local storage data when the browser is closed
	// 	  localStorage.clear();
	// 	});
	//   }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/localstorage.service.ts